module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories wrap"
  }, _vm._l((_vm.products), function(product) {
    return _c('card-product-big', {
      key: product.id,
      staticClass: "margin-bottom",
      attrs: {
        "product": product
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4ee67f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productsCategories.vue
// module id = 667
// module chunks = 5 6